<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <h5>{{ t('skillCertify-proctoring-screen-record-title') }}</h5>
        <p v-html="fullScreenErrorHtml" />
        <div class="btnArea">
          <button @click.stop="onClickClose">{{ t('common-confirm') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { formatTextWithCode } from "~/utils/StringUtil";

const { t } = useI18n();
const dialogStore = useDialogStore();

// ASMT-PROCTOR-14: 평가 시작 전 점검에서 온 경우와 응시 중 재요청은 안내 문구가 다르다.
// 점검 문맥에서는 아직 응시가 시작되지 않았으므로 "평가를 진행하려면"이 아니라 "점검하려면"이다.
const fullScreenErrorKey = computed(() => {
  const props = dialogStore.options.props;
  if (props?.isEnvironmentCheck) return 'skillCertify-environment-check-full-screen-error';
  return props?.isProSkillAssure ? 'skillCertify-proctoring-full-screen-error' : 'challenges-proctoring-full-screen-error';
});

// REQ-313: 공유 선택창을 다시 띄우기 직전 안내라 "전체 화면"(로케일의 **…**)을 굵게 그린다.
const fullScreenErrorHtml = computed(() => formatTextWithCode(t(fullScreenErrorKey.value)));

const onClickClose = () => {
  dialogStore.options.close?.event();
  dialogStore.close();
};

</script>

